import { call, put, takeLatest } from 'redux-saga/effects';
import type { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_API_URL } from '../../api/config';
import ENDPOINTS from '../../api/endPoints';
import {
  fetchCompetitorPromotionRequest,
  fetchCompetitorPromotionSuccess,
  fetchCompetitorPromotionFailure,
} from '../slices/competitorPromotionSlice';
import type {
  CompetitorPromotionResponse,
  CompetitorPromotionData,
  CompetitorInfo,
} from '../../components/competitorPromotions/types';

function* fetchCompetitorPromotionSaga(action: PayloadAction<string>): Generator<any, void, any> {
  try {
    const restaurantId = action.payload;
    const url = `${ENDPOINTS.competitors_promotion}/${restaurantId}`;
    const response = yield call(axios.get, url);

    const apiResponse: CompetitorPromotionResponse = response.data;

    if (apiResponse.data && apiResponse.data.length > 0) {
      const promotionData: CompetitorPromotionData = apiResponse.data[0];
      
      // Parse the competitors_info JSON string
      const competitors: CompetitorInfo[] = JSON.parse(promotionData.competitors_info);

      yield put(
        fetchCompetitorPromotionSuccess({
          data: promotionData,
          competitors: competitors,
        })
      );
    } else {
      yield put(fetchCompetitorPromotionFailure('No competitor promotion data found'));
    }
  } catch (error: any) {
    yield put(
      fetchCompetitorPromotionFailure(
        error.response?.data?.message || error.message || 'Failed to fetch competitor promotion'
      )
    );
  }
}

export function* competitorPromotionSaga() {
  yield takeLatest(fetchCompetitorPromotionRequest.type, fetchCompetitorPromotionSaga);
}
